import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import _ from 'lodash';
import {GAComponentDocumentStatus, documentTypes} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';

export default function dashboardGADocumentsReducer(state = initialstate.dashboardTaskDocuments, action) {
	switch (action.type) {
		case types.GET_DASHBOARD_DOCUMENT_LIST:
			if (action.response) {
				let result;

				const filters = action.filters;
				//delete filters.shared;

				// Normalized data
				let approvals;
				let clientApprovals;
				let tasks;
				let documentReviews;

				if (action.response.data && action.response.data.length > 0) {
					let data = {};

					for (let i = 0; i < action.response.data.length; i++) {
						let document = action.response.data[i];

						for (let i = 0; i < document.clientApprovals.length; i++) {
							if (typeof document.clientApprovals[i].clientSignoffJson === 'string') {
								let objectFromJson;
								try {
									/*turn lastName and firstName into LastName and FirstName*/
									let cleanedUp = document.clientApprovals[i].clientSignoffJson
										.replaceAll(/"firstName"/g, '"FirstName"')
										.replaceAll(/"lastName"/g, '"LastName"')
										.replaceAll(/"SignOffDate"/g, '"CreateDate"')
										.replaceAll(/"createDate"/g, '"CreateDate"')
										.replaceAll(/"userRole"/g, '"UserRole"');
									objectFromJson = JSON.parse(cleanedUp);
								} catch (error) {
									objectFromJson = undefined;
								}
								document.clientApprovals[i] = {
									clientSignOffJson: objectFromJson,
									id: document.clientApprovals[i].id
								};
							}
						}

						let signOffUsers = document.approvals;
						approvals = Utility.normalize(document.approvals, approvals);
						clientApprovals = Utility.normalize(document.clientApprovals, clientApprovals);

						tasks = Utility.normalize(document.tasks, tasks);

						documentReviews = Utility.normalize(document.documentReviews, documentReviews);

						document.filteredEntityIdGuid = action.filteredEntityIdGuid;
						document.approvals = document.approvals && document.approvals.map((approval) => approval.id);
						document.clientApprovals =
							document.clientApprovals && document.clientApprovals.map((clientApproval) => clientApproval.id);
						document.signOffUsers = signOffUsers;
						document.tasks = document.tasks && document.tasks.map((task) => task.id);
						document.documentReviews =
							document.documentReviews && _.map(document.documentReviews, (documentReview) => documentReview.id);
						document.relatedTasksCount = document.tasks && document.tasks.length;
						document.isReturned =
							document.documentTypeId === documentTypes.RETURNEDDOCUMENT ||
							document.gaComponentDocumentStatusID === GAComponentDocumentStatus.Returned
								? true
								: false;
						document.isReadOnly =
							[
								documentTypes.PRIORYEAREVIDENCE,
								documentTypes.CLIENTFILES,
								documentTypes.AUTOMATIONHUBOUTPUT,
								documentTypes.AUTOMATIONHUBCLIENTOUTPUT,
								documentTypes.GROUPCOMPONENTINSTRUCTIONDOCUMENT,
								documentTypes.RETURNEDDOCUMENT
							].indexOf(document.documentTypeId) !== -1
								? true
								: false;

						data[action.response.data[i].id] = document;
					}

					result = {
						...state,
						[action.parentName]: {
							...state[action.parentName],
							filters,
							filterKey: action.filterKey,
							response: {
								data: data,
								page: action.response.page,
								pages: action.response.pages,
								totalEntityCount: action.response.totalEntityCount
							},
							documents: {
								allIds: action.response.data.map((document) => document.id)
							},
							approvals,
							clientApprovals,
							userPresence: Utility.normalize(),
							tasks,
							documentReviews
						}
					};

					// There are no documents for this query
				} else {
					result = {
						...state,
						[action.parentName]: {
							...state[action.parentName],
							filters,
							filterKey: action.filterKey,
							response: {
								data: {},
								page: action.response.page,
								pages: action.response.pages,
								totalEntityCount: action.response.totalEntityCount
							},
							approvals: Utility.normalize(),
							clientApprovals: Utility.normalize(),
							documentReviews: Utility.normalize(),
							documents: Utility.normalize(),
							userPresence: Utility.normalize()
						}
					};
				}
				// Document upload is in progress and switching tabs and same document is present in other tab then do not show progress bar of exisitng doument and exclude document from documents list and keep only in upload list.
				if (
					result &&
					result[action.parentName] &&
					result[action.parentName].upload &&
					result[action.parentName].upload.allIds &&
					result[action.parentName].upload.allIds.length > 0
				) {
					let documents;
					let parentName = action.parentName;
					result[parentName].upload.allIds.forEach((uploadDocumentId) => {
						documents = result[parentName].documents.allIds.filter((documentId) => documentId !== uploadDocumentId);
					});
					result[parentName] = {
						...result[parentName],
						documents: {
							allIds: documents
						}
					};
				}
				return result;
			}

			return state;
		default:
			return state;
	}
}
